export default function (state, getters, rootState, rootGetters) {
  let items = [];
  if (rootGetters.permission(191)) items.push({
    name: 'Туры',
    href: '/tourclient/spa/#/search/',
    icon: 'mag-icon-nav-menu-search-tours',
    spa: '',
    min: true,
    link: true,
  });

  if (rootGetters.permission(192)) items.push({
    name: 'Авиабилеты',
    href: '/tourclient/flightsearch/flights.html',
    icon: 'mag-icon-nav-menu-search-flights',
    spa: '',
    min: true,
    link: true,
  });
  if (rootGetters.permission(193)) items.push({
    name: 'Отели',
    href: '/tourclient/hotelsearch/hotels.html',
    icon: 'mag-icon-nav-menu-search-hotels',
    spa: '',
    min: true,
    link: true,
  });
  if (rootGetters.permission(194)) items.push({
    name: 'Страховки',
    href: '/tourclient/insurances',
    icon: 'mag-icon-nav-menu-search-insurance',
    spa: '',
    min: true,
    link: true,
  });
  if (rootGetters.permission(358)) items.push({
    name: 'Мои туры',
    href: '/app/#/tour',
    icon: 'mag-icon-nav-menu-search-tours',
    spa: '',
    min: true,
    link: true,
  });

  if (rootGetters.permission(183)) items.push({
    name: 'Путевки',
    href: '/tourclient/spa/#/orders',
    icon: 'mag-icon-nav-menu-orders',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(184)) items.push({
    name: 'Туристы',
    href: '/tourclient/admin/clients/list.html',
    icon: 'mag-icon-nav-menu-clients',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(185)) items.push({
    name: 'Лиды',
    href: '/tourclient/spa/#/leads/list/',
    icon: 'mag-icon-nav-menu-leads',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(186)) items.push({
    name: 'Финансы',
    href: '',
    icon: 'mag-icon-nav-menu-payments',
    spa: '/finances',
    min: false,
    link: true,
  });

  if (rootGetters.permission(152)) items.push({
    name: 'Статистика',
    href: '/tourclient/admin/statistic/index.html',
    icon: 'mag-icon-nav-menu-statistic',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(187)) items.push({
    name: 'Задачи',
    href: '/tourclient/admin/tasks/list.html',
    icon: 'mag-icon-nav-menu-tasks',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(190)) items.push({
    name: 'События',
    href: '/tourclient/admin/events/index.html',
    icon: 'mag-icon-nav-menu-events',
    spa: '',
    min: false,
    link: true,
  });
  if (rootGetters.permission(218)) items.push({
    name: 'Звонки',
    href: '/tourclient/spa/#/telephony/journal',
    icon: 'mag-icon-nav-menu-phone-calls',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(188)) items.push({
    name: 'Партнеры',
    href: '/tourclient/admin/partners/list.html',
    icon: 'mag-icon-nav-menu-partners',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(189)) items.push({
    name: 'Справочники',
    href: '/tourclient/admin/dicts/index.html',
    icon: 'mag-icon-nav-menu-directories',
    spa: '',
    min: false,
    link: true,
  });

  items.push({
    name: 'Личный кабинет',
    href: '/tourclient/admin/',
    icon: 'mag-icon-nav-menu-lk',
    spa: '',
    min: false,
    link: true,
  });

  if (rootGetters.permission(270)) {
    items.push({
      name: 'Сертификаты',
      href: '/tourclient/index.html#/finances/certificates/search',
      icon: 'mag-icon-nav-menu-certificates',
      spa: '',
      min: false,
      link: true,
    });
  }
  if (rootGetters.permission(305)) {
    items.push({
      name: 'Дотации',
      href: '/tourclient/index.html#/finances/subsidies/search',
      icon: 'mag-icon-nav-menu-certificates',
      spa: '',
      min: false,
      link: true,
    });
  }
  if (rootGetters.permission(339)) {
    items.push({
      name: 'Зарплата и премии',
      href: '/tourclient/dictionary/#/admin/salary',
      icon: 'template-icon-salary',
      spa: '',
      min: false,
      link: true,
    });
  }

  return items;
}
